import React from 'react'
import { Cart } from '../components/cart'
import { mount } from '../utils/mount'

mount('#cart-root', <Cart />)
